import { Component } from 'react';

import './styles.scss';

export default class FormHr extends Component {
  render() {
    return (
      <div className="formHr">
        <hr />
      </div>
    );
  }
}
